import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../bar/Header";
import Footer from "../bar/Footer";

//BACKGROUND IMG
import backImg from '../../assets/imgs/back24-25.png'

export default function BarLayout() {
    const location = useLocation();

    if (location.pathname == '/bar') {
        return <Navigate to="/bar/home"/>
    }

    return (
        <div className='main-content' style={{backgroundImage: `url(${backImg})`}}>
            <Header/>
            <Outlet/>
            <Footer/>
        </div>
    )
}
